import './SubChapterCard.scss';
import Component from './SubChapterCard';
export default Component;